var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 14,
    width: 30,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19C5 16.2386 7.23858 14 10 14H30C32.7614 14 35 16.2386 35 19V30C35 32.7614 32.7614 35 30 35H10C7.23858 35 5 32.7614 5 30V19Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 19C5 16.2386 7.23858 14 10 14H30C32.7614 14 35 16.2386 35 19V35.25C35 38.0114 32.7614 40.25 30 40.25H10C7.23858 40.25 5 38.0114 5 35.25V19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19C5 16.2386 7.23858 14 10 14H30C32.7614 14 35 16.2386 35 19V30C35 32.7614 32.7614 35 30 35H10C7.23858 35 5 32.7614 5 30V19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19C5 16.2386 7.23858 14 10 14H30C32.7614 14 35 16.2386 35 19V30C35 32.7614 32.7614 35 30 35H10C7.23858 35 5 32.7614 5 30V19Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_38_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 33,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51562 5.33331H37V36H4.51562V5.33331Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_38_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7002 6.18439H31.6843V8.92742C31.6843 10.2285 30.6463 11.2368 29.3842 11.2368H29.2422C27.9474 11.2368 26.9422 10.1905 26.9422 8.92742V6.18439H14.3604V8.92742C14.3604 10.2285 13.3169 11.2368 12.0603 11.2368H11.9128C10.618 11.2368 9.61281 10.1905 9.61281 8.92742V6.18439H7.81541C6.01801 6.18439 4.58118 7.62638 4.58118 9.43158V32.7474C4.58118 34.5526 6.01801 36 7.81541 36H29.0619L30.5698 35.962C30.7501 35.8916 30.9303 35.8157 31.0779 35.6747L36.2898 30.1128C36.3608 30.0423 36.3936 29.9718 36.4701 29.8959C36.7541 29.5381 36.9017 29.1044 36.9017 28.6708V9.43158C36.9344 7.62638 35.4976 6.18439 33.7002 6.18439ZM30.537 32.8937V30.0802C30.537 29.5381 30.9686 29.1424 31.4712 29.1424H34.0936L30.537 32.8937ZM34.6344 26.8276H31.4712C29.6738 26.8276 28.237 28.275 28.237 30.0802V33.7231H7.81541C7.27455 33.7231 6.8812 33.2895 6.8812 32.7853V14.5599H34.6727V26.8276H34.6344Z",
    fill: "#E6C357"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_38_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 4,
    width: 4,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4H14V10.8385H10V4Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_38_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3386 10.2083C13.0261 10.2083 13.6042 9.61458 13.6042 8.92187V5.28125C13.6042 4.58854 13.0261 4 12.3386 4H12.2031C11.5156 4 10.9323 4.58854 10.9323 5.28125V8.95833C10.9323 9.65104 11.5156 10.2396 12.2031 10.2396H12.3386V10.2083Z",
    fill: "#E6C357"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_38_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 4,
    width: 4,
    height: 7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4H32V10.8385H28V4Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_38_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5573 10.2083C30.2448 10.2083 30.8281 9.61458 30.8281 8.92187V5.28125C30.8281 4.58854 30.2448 4 29.5573 4H29.4219C28.7344 4 28.1511 4.58854 28.1511 5.28125V8.95833C28.1511 9.65104 28.7344 10.2396 29.4219 10.2396H29.5573V10.2083Z",
    fill: "#E6C357"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1302 17.25H12.6666V19.8125H10.1302V17.25Z",
    fill: "#E6C357"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8854 17.25H18.4219V19.8125H15.8854V17.25Z",
    fill: "#E6C357"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6458 17.25H24.1823V19.8125H21.6458V17.25Z",
    fill: "#E6C357"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3698 17.25H29.9063V19.8125H27.3698V17.25Z",
    fill: "#E6C357"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1302 22.1719H12.6666V24.7396H10.1302V22.1719Z",
    fill: "#E6C357"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8854 22.1719H18.4219V24.7396H15.8854V22.1719Z",
    fill: "#E6C357"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6458 22.1719H24.1823V24.7396H21.6458V22.1719Z",
    fill: "#E6C357"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3698 22.1719H29.9063V24.7396H27.3698V22.1719Z",
    fill: "#E6C357"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1302 27.1302H12.6666V29.6979H10.1302V27.1302Z",
    fill: "#E6C357"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8854 27.1302H18.4219V29.6979H15.8854V27.1302Z",
    fill: "#E6C357"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6458 27.1302H24.1823V29.6979H21.6458V27.1302Z",
    fill: "#E6C357"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/iconCalendar.28eb62cd.svg";
export { ForwardRef as ReactComponent };